import { createActionConfig } from './create-action-config';

export const type = '@appcues/update-profile';
export const getUserProperties = config =>
  createActionConfig({
    type,
    config,
  });
